import request from '@/utils/request'

// 生产环境api路径

// 根据字母返回期刊
export function queryJournalBySubject (data) {
  return request({
    data: data,
    url: '/old/api/queryJournalBySubject',
    method: 'post'
  })
}

// 期刊图表数据
export function queryJournalStats2 (data) {
  return request({
    data: data,
    url: '/old/api/queryJournalStats2 ',
    method: 'post'
  })
}
// 开发环境api路径

// // 根据字母返回期刊
// export function queryJournalBySubject (data) {
//   return request({
//     data: data,
//     url: 'api/api/queryJournalBySubject',
//     method: 'post'
//   })
// }

// // 期刊图表数据
// export function queryJournalStats2 (data) {
//   return request({
//     data: data,
//     url: 'api/api/queryJournalStats2',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/perioducal.js